import {
  type DispatcherEvent,
  generateNativeMessageSender
} from '@carvana/merch-native';
import { isNonProd } from '~/constants/environment';
import { logError } from '~/utilities/loggers';
import { source, type VdpDispatcherEvent } from './constants';

export default generateNativeMessageSender<
  DispatcherEvent | VdpDispatcherEvent
>({
  logError,
  source,
  verboseLogs: isNonProd
});
